<template>
  <div ref="printContent" class="print-container">
    <div class="print-content">
      <Watermark />
      <section
        class="border border-dark font-modify m-5"
        style="background-color: transparent"
      >
        <div
          class="border border-dark p-1"
          style="
            display: flex;
            justify-content: center;
            background-color: transparent;
          "
        >
          <h3 style="text-align: center; width: 100%">Operative Notes</h3>
        </div>
        <div
          class="border border-dark p-1"
          style="
            display: flex;
            justify-content: space-between;
            background-color: transparent;
          "
          dir="ltr"
        >
          <span>
            <p class="px-1" style="background-color: transparent">
              Name: {{ patientSurgeryData.patient_card.patient.name }}
            </p>
          </span>
          <span>
            <p class="px-4" style="background-color: transparent">
              Age:{{ patientSurgeryData.patient_card.patient.birth_date }}
            </p>
          </span>
        </div>

        <table
          style="
            width: 100%;
            table-layout: fixed;
            background-color: transparent;
          "
          dir="ltr"
        >
          <tr style="height: 60px">
            <th class="px-1" style="text-align: left">
              <!-- Surgon :{{ patientSurgeryData.doctor_surgery.doctor_name }} -->
            </th>
            <th
              v-if="
                patientSurgeryData.surgery_staff.length &&
                patientSurgeryData.surgery_staff[0].employee
              "
              class="px-1"
              style="text-align: left"
            >
              Anaesthetist :{{
                patientSurgeryData.surgery_staff[0].employee.full_name
              }}
            </th>

            <th
              v-if="
                patientSurgeryData.surgery_staff.length &&
                patientSurgeryData.surgery_staff[0].employee
              "
              class="px-1"
              style="text-align: left"
            >
              Nurse :
              {{ patientSurgeryData.surgery_staff[0].employee.full_name }}
            </th>
          </tr>
          <tr class="px-1" style="height: 60px">
            <th
              v-if="patientSurgeryData.doctor_assist.length"
              class="px-1"
              style="text-align: left"
            >
              Assiatant : {{ patientSurgeryData.doctor_assist[0].name }}
            </th>
            <th class="px-1" style="text-align: left">Anaesthetsia:</th>

            <th class="px-1" style="text-align: left" />
          </tr>
        </table>
      </section>
      <div
        class="font-modify mt-1 mx-5"
        dir="rtl"
        style="
          text-align: right;
          font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
          background-color: transparent;
          padding: 15px;
        "
      >
        <h4 style="text-align: center; margin-bottom: 10px">Procedure</h4>
        <p
          style="
            background-color: transparent;
            padding: 10px;
            text-align: right;
          "
        >
          {{ patientSurgeryData.procedure }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Watermark from "@/components/common/Watermark.vue";

export default {
  name: "OperativeNotesPrint",
  components: {
    Watermark,
  },
  props: {
    patientSurgeryData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async print() {
      const printWindow = window.open("", "_blank");
      const { printContent } = this.$refs;

      // Get watermark image source
      const watermarkImg = printContent.querySelector(".watermark-image");
      const watermarkSrc = watermarkImg ? watermarkImg.src : "";

      // Clone the content and update image sources
      const contentClone = printContent.cloneNode(true);
      const watermarkClone = contentClone.querySelector(".watermark-image");
      if (watermarkClone && watermarkSrc) {
        watermarkClone.src = watermarkSrc;
      }

      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>Operative Notes</title>
            <style>
              @page {
                size: A4;
                margin: 20mm;
              }
              body {
                font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
                margin: 0;
                padding: 0;
                background-color: transparent;
              }
              .print-content {
                position: relative;
              }
              .print-content > section,
              .print-content > div:not(.watermark-wrapper) {
                position: relative;
                z-index: 10 !important;
                background-color: transparent !important;
              }
              .print-content h1,
              .print-content h3,
              .print-content h4 {
                position: relative;
                z-index: 10 !important;
                text-align: center !important;
                background-color: transparent !important;
              }
              .print-content p,
              .print-content table,
              .print-content th,
              .print-content td,
              .print-content span,
              .print-content div {
                position: relative;
                z-index: 10 !important;
                background-color: transparent !important;
              }
              .print-content table th,
              .print-content table td {
                background-color: transparent !important;
              }
              .watermark-wrapper {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 0 !important;
                pointer-events: none;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .watermark-image {
                opacity: 0.2;
                max-width: 400px;
                max-height: 400px;
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            </style>
          </head>
          <body>
            ${contentClone.innerHTML}
          </body>
        </html>
      `);

      printWindow.document.close();
      printWindow.onload = () => {
        printWindow.print();
        printWindow.close();
      };
    },
  },
};
</script>

<style scoped lang="scss">
.print-container {
  display: none;
}

@media print {
  .print-container {
    display: block;
    position: relative;
    width: 100%;
    min-height: 100vh;
  }

  .print-content {
    position: relative;
    z-index: 1;
  }

  .print-content > section,
  .print-content > div:not(.watermark-wrapper),
  .print-content > h1,
  .print-content > h4,
  .print-content > p,
  .print-content > table {
    position: relative;
    z-index: 10 !important;
    background: transparent;
  }

  .font-modify {
    letter-spacing: normal !important;
  }
}
</style>
